
// Vue
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace, Getter, Mutation, Action, State } from "vuex-class";
import { MapSetupLayer, MapSetupGroup } from "@/store/map-setup/types";
import { validationMixin } from "vuelidate";
import { maxLength, minLength, integer, required } from "vuelidate/lib/validators";

// Types

// Third Party

// Components

// Namespaces
const MapSetup = namespace("mapSetup");

@Component({
	mixins: [validationMixin],
	validations: {
		MapLayerDataObject: {
			title: {
				required,
				minLength: minLength(3),
				maxLength: maxLength(250)
			},
			minElevation: {
				integer
			},
			maxElevation: {
				integer
			}
		}
	}
})
export default class MapLayerSetup extends Vue {
	// map layer passed in from map setup page, could be new or existing

	@Prop({ default: null }) public MapLayer: MapSetupLayer;
	@Prop({ default: null }) public Dimensions: object;

	@MapSetup.Action addUpdateMapLayer: (mapLayer: FormData) => Promise<void>;
	@MapSetup.Action deleteMapLayer: (mapLayer: MapSetupLayer) => Promise<void>;

	@MapSetup.Mutation addMapLayer: (mapLayer: MapSetupLayer) => void;
	@MapSetup.Mutation removeMapLayer: (mapLayerId: number) => void;

	private isEditMode: boolean = true;
	private MapLayerTemplate: MapSetupLayer; // The thing we validate against and reset to
	private loading: boolean = false;

	// Delete dialog
	private isDeleteMapLayerVisible: boolean = false;
	private isSafeDeleteEnabled: boolean = false; // Do we use safe delete method of deleting?
	private safeDeleteInput = "";

	// local objec to use for our data
	private MapLayerDataObject: MapSetupLayer = new MapSetupLayer();

	public mounted() {
		// if an item has been passed in, copy over the values to our local object
		if (this.MapLayer) {
			this.MapLayerDataObject = this.MapLayer;
		}

		this.MapLayerTemplate = Object.assign({}, this.MapLayerDataObject);
		this.safeDeleteInput = "";
	}

	public async saveMapLayerDetails() {
		this.loading = true;
		let updatedLayer = { ...this.MapLayerDataObject };

		if (!updatedLayer.mapLayerId) {
			updatedLayer.mapLayerId = 0;
		}

		// @ts-ignore
		delete updatedLayer.layerItems;
		// @ts-ignore
		delete updatedLayer.visible;

		if (this.file) {
			updatedLayer.image = this.file;
		} else {
			// @ts-ignore
			updatedLayer.image = this.MapLayer.image ? this.dataURItoBlob(this.MapLayer.image) : undefined;
		}

		let formData = new FormData();

		for (let [name, value] of Object.entries(updatedLayer)) {
			formData.append(name, value as any);
		}

		this.addUpdateMapLayer(formData).then(result => {
			this.toggleEdit();

			this.$emit("closeLayerSetup", "save");
		});
	}
	private dataURItoBlob(dataURI) {
		// convert base64/URLEncoded data component to raw binary data held in a string
		let byteString;
		if (dataURI.split(",")[0].indexOf("base64") >= 0) {
			byteString = atob(dataURI.split(",")[1]);
		} else {
			byteString = unescape(dataURI.split(",")[1]);
		}

		// separate out the mime component
		let mimeString = dataURI
			.split(",")[0]
			.split(":")[1]
			.split(";")[0];

		// write the bytes of the string to a typed array
		let ia = new Uint8Array(byteString.length);
		for (let i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}

		return new Blob([ia], { type: mimeString });
	}
	public resetMapLayerData() {
		this.MapLayerDataObject = Object.assign({}, this.MapLayerTemplate);
		this.toggleEdit();
		this.$emit("closeLayerSetup");
	}

	public deleteMapLayerDialog() {
		this.isDeleteMapLayerVisible = true;
	}
	public deleteLayer() {
		this.loading = true;
		this.deleteMapLayer(this.MapLayerDataObject).then(result => {
			this.$emit("closeLayerSetup");
		});
		this.isDeleteMapLayerVisible = false;
	}

	public toggleEdit() {
		this.isEditMode = !this.isEditMode;
	}
	public get isEditModeEnabled() {
		return this.isEditMode;
	}

	private changeImage: boolean = false;

	private file = null;

	private previewImgSrc = null;

	@Watch("file")
	private onFileChanged(val) {
		if (!val) {
			return;
		}

		if (this.previewImgSrc) {
			this.previewImgSrc = null;
		}

		const fileReader = new FileReader();

		fileReader.onload = e => {
			this.previewImgSrc = e.target.result;
			this.$emit("layerImageChanged", this.previewImgSrc);
		};

		fileReader.readAsDataURL(this.file);
	}
}
